<script lang="ts">
	import { Icon } from '$lib/components/atoms/Icon';
  import classnames from 'classnames';
  import { getContext } from 'svelte';
  import { cubicInOut } from 'svelte/easing';
  import type { Writable } from 'svelte/store';
  import { fade } from 'svelte/transition';

  const context: { hideStickyFilters: Writable<boolean> } = getContext('FILTERS');

  if (context && context.hideStickyFilters) {
    context.hideStickyFilters.subscribe((hide) => {
      if (hide) {
        open = false;
      }
    });
  }

  export let title: string;

  export let grouped = false;
  export let open = false;
  let dropdown: HTMLElement;
  let dropdownMenu: HTMLElement;
  export let closeOnSelect = false;
  export let currentValue;

  const onDropdownClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (!dropdownMenu || !dropdownMenu.contains(target)) {
      open = !open;
    }
  };

  // /*const onChange = (e: any) => {
  //   let checkedValues = [];
  //   let rangeValues = [];

  //   dropdownMenu.querySelectorAll("input").forEach(input => {
  //     const label = dropdownMenu.querySelector<HTMLLabelElement>(`label[for=${input.id}]`);

  //     if (["checkbox", "radio"].includes(input.type) && input.checked) {
  //       checkedValues.push(label?.innerText ?? "1 selezione");
  //     }

  //     if (["range"].includes(input.type) && input.value) {
  //       rangeValues.push(input.value);
  //     }
  //   })

  //   filterDescription = checkedValues.join(", ") + rangeValues.join(" - ");

  //   if(closeOnSelect && open){
  //       open = false;
  //   }
  // }*/

  const onGlobalClick = (e) => {
    const target = e.target as HTMLElement;

    if (open && !dropdown.contains(target)) {
      open = false;
    }
  };
</script>

<svelte:window on:click={onGlobalClick} />

<div class="filter-dropdown-wrapper" class:open bind:this={dropdown}>
  {#if open}
    <div
      class="filter-backdrop"
      in:fade={{ duration: 300, easing: cubicInOut }}
      out:fade={{ duration: 300, easing: cubicInOut }}
      on:click={() => (open = false)}
    />
  {/if}

  <div class="filter-dropdown" on:click={onDropdownClick}>
    <div class="filter-dropdown-visible-part">
      <div class="filter-dropdown-preview" class:compact={!!currentValue}>
        <span class="filter-dropdown-title">{title}</span>
        {#if currentValue}
          <span class="filter-dropdown-description">{currentValue}</span>
        {/if}
      </div>
      <span class="filter-dropdown-icon">
        <Icon icon="chevron-down" />
      </span>
    </div>
    <div
      class={classnames('filter-dropdown-menu', {
        grouped: grouped,
        'space-y-5': grouped,
        'space-y-4': !grouped,
      })}
      bind:this={dropdownMenu}
    >
      <slot />
    </div>
  </div>
</div>

<style type="text/scss" lang="scss" scoped>
  .filter-dropdown-wrapper {
    @apply border border-gray-300;
    @apply rounded;
    @apply md:border-0 md:rounded-none;
    /* Equal widths between filter wrappers */
    flex: 1 1 0px;
    min-width: 0;

    /* Set max-width of 1/4 when not every filter is visible  */
    @screen md {
      max-width: 25%;
    }

    &.open {
      @apply relative z-modal;
    }
  }

  .filter-dropdown {
    @apply flex flex-wrap items-center;
    @apply bg-white;
    @apply px-4 min-h-[60px] rounded;
    @apply cursor-pointer;
    @apply transition-colors duration-300 delay-75;
    @apply md:border md:border-gray-300;
    @apply md:flex-nowrap md:relative;
    @apply md:h-[60px];

    .open & {
      @apply md:rounded-b-none md:z-filter;
      @screen md {
        border-bottom-color: transparent;
      }
    }

    @screen md {
      :not(.open) &:hover {
        @apply bg-gray-50;
      }
    }
  }

  .filter-dropdown-visible-part {
    @apply flex w-full;
  }

  .filter-dropdown-preview {
    @apply flex flex-col;
    @apply text-sm;
    @apply py-5;
    /* Avoid text overflow outside the filter component */
    flex: 1 1 0px;
    min-width: 0px;

    &.compact {
      @apply py-2.5;
    }
  }

  .filter-dropdown-title {
    @apply tracking-widest uppercase;
  }

  .filter-dropdown-description {
    @apply font-semibold;
    @apply truncate;
  }

  .filter-dropdown-icon {
    @apply inline-flex self-center;
    @apply transition-transform duration-200;
    .open & {
      @apply transform rotate-180;
    }
  }

  .filter-dropdown-menu {
    @apply flex flex-col;
    @apply py-5;
    @apply bg-white;
    @apply md:absolute md:inset-x-0 md:top-full;
    @apply md:box-content md:w-auto;
    @apply md:max-h-[450px] md:overflow-y-auto;
    @apply md:rounded-b md:rounded-tr md:border md:border-gray-300;
    @apply md:px-5 md:-mt-px md:-mx-px;
    width: calc(100% + 2rem);
    padding-right: 0.8rem;

    @apply hidden;
    @apply transform scale-y-95 origin-top;
    @apply transition-transform duration-300 ease-smooth;
    .open & {
      @apply flex;
      @apply scale-y-100;
    }
  }

  :global(.filter-dropdowns) .filter-dropdown-wrapper:last-child .filter-dropdown-menu {
    @apply md:rounded-tr-none md:rounded-tl;
    left: -4rem;
  }

  :global(.filter-dropdown-menu.grouped > * + *) {
    @apply pt-5;
    @apply border-t border-gray-300 border-opacity-50;
  }

  .filter-backdrop {
    @apply hidden md:block;
    @apply fixed inset-0;
    @apply bg-gray-900 bg-opacity-10;
    @apply z-filter;
  }

  :global(.apply-button) {
    @apply flex;
    @apply min-w-36;
  }
</style>
